<template>
    <div id="app" v-if="isLogin">
        <div class="layout-wrap" style="padding-top: 40px;">
            <!-- <img src="./static/logo.png"> -->
            <!--<Header :LoginInfoCheckedFlag = "LoginInfoCheckedFlag" v-show="LoginInfoCheckedFlag"></Header>-->
            <Header :LoginInfoCheckedFlag = "LoginInfoCheckedFlag"
                    v-show="LoginInfoCheckedFlag"></Header>
            <Side-Bar v-if="getGovMenuAuth !== null"
                      v-show="LoginInfoCheckedFlag"></Side-Bar>


            <router-view v-if="getGovMenuAuth !== null"
                         :key="$route.fullPath"></router-view>
            <Footer v-if="getGovMenuAuth !== null"
                    :LoginInfoCheckedFlag = "LoginInfoCheckedFlag"
                    v-show="LoginInfoCheckedFlag"
                    style="padding-top: 40px;"></Footer>
            <!--<Footer v-if="getGovMenuAuth !== null"  :LoginInfoCheckedFlag = "LoginInfoCheckedFlag" v-show="LoginInfoCheckedFlag"></Footer>-->
        </div>
        <policy-help v-if="viewPolicyHelp"></policy-help>
    </div>
</template>


<script>
    import GNB from './components/common/layout/gnb/gnb.vue'
    import LNB from './components/common/layout/lnb/lnb.vue'
    import FNB from './components/common/layout/fnb/fnb.vue'

    import ssoService from '@/services/common/keycloak.service';
    import {mapGetters} from 'vuex';
    import store from './store/index'
    import { EventBus } from "./components/common/event-bus"
    import PolicyHelp from './components/policy/policyHelp.vue';

    export default {
        name: 'App',
        store,
        components: {
            'Header': GNB,
            'Side-Bar': LNB,
            'Footer': FNB,
            'policy-help': PolicyHelp
        },
        data: function() {
            return {
                LoginInfoCheckedFlag: false,
                viewPolicyHelp: false
            }
        },
        computed: {
            ...mapGetters({
                isLogin : 'user/isLogin',
                loginUser: 'user/loginUser'
            }),
            getLocale: function() {
                $('html').attr('lang', this.$i18n.locale);
                return this.$i18n.locale;
            },
            getGovMenuAuth: function() {
                return this.$store.state.GOV_MENU_AUTH
            }
        },
        watch: {
            getLocale: function() {
                this.$store.dispatch('common/setLang', this.$i18n.locale);
                this.broadcastingLocaleChanged()
            }
            ,
            loginUser: function() {
                this.trackGAData();
            }
        },
        created: function () {
            this.getApiByEnviroment()
            this.setEventViewPolicyHelp()

        },
        methods: {
            // 운영환경 별 API 서버 정보 조회
            getApiByEnviroment(){
                this.http.get(`/api/general/frontProfile`, {
                        excludeToken: true,
                    })
                    .then(result => {
                        return result.data;
                    })
                    .then(json => {
                        this.profile.env = this.urls.profile = json.env;

                        // 개발 / 운영계 별도 토큰 관리
                        this.$store.commit('setTokenKey' ,
                            this.profile.env === this.constants.LOCAL
                            || this.profile.env === this.constants.DEV
                                ? this.constants.ACCESS_TOKEN_DEV
                                : this.constants.ACCESS_TOKEN);
                        this.ssoStart()
                    });
            },
            // 인증 Start
            ssoStart(){

                const pathname = location.pathname

                let tokenKey = this.$store.state.ACCESS_TOKEN_KEY;
                const hash = window.location.hash;
                const redirect_token = this.getQueryParams(this.constants.ACCESS_TOKEN);

                const access_token = this.$cookies.get(tokenKey);

                let whiteDomain = this.getWhiteLabelDomain(window.location.hostname)
                this.$store.commit('setSubDomain', whiteDomain)

                // keycloak init
                this.$cookies.remove(tokenKey, '/', this.$store.state.sub_domain);
                //this.$cookies.set(this.tokenKey, null, '1y', '/', typeof (this.$store.state.sub_domain) !== this.constants.UNDEFINED ? this.$store.state.sub_domain : '');
                ssoService.init(this.urls.apiGwUrl).then((keycloak) => {

                    keycloak.onReady = () => {
                        if (!ssoService.isLoggedIn()) {
                            ssoService.login();
                        }
                    };

                    // 로그인 성공한 후 리다이렉트 될 경우 아래 이벤트 호출됨
                    keycloak.onAuthSuccess = async () => {
                        this.$cookies.set(tokenKey, keycloak.token, '1y', '/', this.$store.state.sub_domain);
                        this.$store.dispatch('user/getLoginUser');
                        this.LoginInfoCheckedFlag = true;
                        //this.getLoginUser();
                    };

                    keycloak.onAuthError = () => {
                        console.log('Auth Error');
                    };

                    // 토큰이 만료될 경우 아래 로직 호출됨 (토큰 갱신)
                    keycloak.onTokenExpired = () => {
                        keycloak.updateToken(5).success(() => {
                            this.$cookies.set(tokenKey, keycloak.token, '1y', '/', this.$store.state.sub_domain);
                        }).catch(() => {
                            this.$store.commit('user/SET_TOKEN_EXPIRATION', true);
                        });
                    };
                });
                // this.getLoginUser();
            },
            // getAccessTokenCheck(access_token, hash) {
            //     const url = `${this.urls.ssoUrl}/oauth/validate_token?token=${access_token}`
            //
            //     //token 유효성 검사 API 호출
            //     this.http.get(url)
            //         .then(result => {
            //             if(result.data.status == 'ok') {
            //                 // response가 ok일때 dashboard로 호출
            //                 this.getLoginUser(hash)
            //                 //this.getHomepageInfo()
            //             }
            //         })
            //         .catch(err => {
            //             this.$cookies.set(this.tokenKey, null, -1,'/', typeof(this.$store.state.sub_domain) !== this.constants.UNDEFINED ? this.$store.state.sub_domain : '')
            //             location.href = `${this.urls.ssoUrl}/logout?access_token=${access_token}&redirect_uri=${this.urls.govUrl}`
            //         });
            // },
            getLoginUser() {
                let self = this;
                const url = `/api/users/current-logged-in`

                this.http.get(url)
                    .then(result => {
                        if(result.data.status === 'ok') {
                            if (result.data.result) {
                                return result.data.result
                            } else {
                                throw new Error('AdminLoginUserAPICallDenied');
                            }
                        } else {
                            throw new Error('AdminAPIServerError');
                        }

                        // TODO : Trial 처리 나중에
                        // if(rsp.result.trialYn == 'Y' && rsp.result.trialRemainDays == 0){
                        //     console.log(global['loginUser'],urls.portalUrl )
                        //     location.href = `${urls.portalUrl}`
                        //     return;
                        // }∂
                        // if (result.data.result && result.data.result.userId) {
                        //     this.$store.commit('setLoginUser', result.data.result)
                        // } else {
                        //     this.login()
                        // }

                    })
                    .then(async json => {
                        // this.loading = true;
                        self.$store.commit("setAccessDenied", false);

                        if (json.siteCd === "BESPIN") {
                            //동시 로그인 제한 설정 관련 체크
                            self.$store.commit("setLoginDeniedConCurrent", false);
                            if (json.useConcurrent !== '1') {
                                self.$store.commit("setLoginDeniedConCurrent", true);
                            }
                            //MFA 2단계 인증 설정여부
                            self.$store.commit("setOtpDenied", false);
                            if (json.useOtp === '0') {
                                self.$store.commit("setOtpDenied", true);
                            }
                            // ip 있는지 없는지 체크
                            self.$store.commit("setAllowedIpNull", false);
                            if (json.allowedIpaddr == null) {
                                self.$store.commit("setAllowedIpNull", true);
                            }
                            // ip addr입력되었을때 ip 유효성 체크
                            self.$store.commit("setAllowedIpDenied", false);
                            if (json.passIpaddr !== 'Y') {
                                self.$store.commit("setAllowedIpDenied", true);
                            }
                            // 오류가 있으면 로그인 정보를 받아오지 않음.
                            if (self.$store.state.accessDenied || self.$store.state.otpDenied || self.$store.state.allowedIpNull || self.$store.state.allowedIpDenied || self.$store.state.loginDeniedConCurrent)
                                return;

                            // if (json.userId) {
                                //self.$store.commit('setSiteId' , result.data.loginUserInfo.result.siteCd);

                                //self.getAuthMenuList();
                            // }
                            // else {
                            //     self.LoginInfoCheckedFlag = false;
                            // }
                        }
                        self.$store.commit('setLoginUser', json);

                        self.LoginInfoCheckedFlag = true;
                    })
                    // .catch(error => {
                    //     if (error.code === '470' || error.code === '406') {
                    //         self.$store.commit("setAccessDenied" , true);
                    //         throw new Error('AdminAccessDenied');
                    //     }
                    //     throw new Error('AdminLoginUserAPICallDenied');
                    // })
            },
            // login() {
            //     const url = `${this.urls.ssoUrl}/oauth/clientId`
            //
            //     let client_id = ''
            //     let hash = window.location.hash
            //     let redirect_url = (hash == '/' || hash == '#/') ? '%23/dashboard' : hash.replace('#', '%23')
            //     this.http.get(url)
            //         .then((result) => {
            //             if (result.data.client_id) {
            //                 client_id = result.data.client_id
            //                 location.href = `${this.urls.ssoUrl}/oauth/authorize/sitecode/token?response_type=token&client_id=${client_id}&redirect_uri=${window.location.href}${redirect_url}&scope=all&state=`
            //             }
            //         })
            // },
            getQueryParams(param) {
                var result = window.location.search.match(
                    new RegExp("(\\?|&)" + param + "(\\[\\])?=([^&]*)")
                )
                return result ? result[3] : false
            },
            getWhiteLabelDomain(hostname) {
                return '.' + hostname.split('.').slice(1).join('.')
            },
            broadcastingLocaleChanged: function(){
                EventBus.$emit('changeLocale', this.getLocale);
            },
            setEventViewPolicyHelp: function() {
                // 도움말 펼치기/닫기
                EventBus.$on("toggleViewPolicyHelp", e => {
                    $('body').toggleAttr('data-help','on')
                    this.viewPolicyHelp = !this.viewPolicyHelp
                });

                // 도움말 닫기
                EventBus.$on("closeViewPolicyHelp", e => {
                    $('body').removeAttr('data-help')
                    this.viewPolicyHelp = false
                });
            },
            trackGAData: function() {
                window['dataLayer'].push({
                    // user id to track individual
                    'user_id' : this.loginUser.userId,
                    // user id
                    'crm_id' : this.loginUser.userEmail,
                    // site name ex) BespinGlobal(OpsNow) or WL
                    'site_name' : this.loginUser.siteCd,
                    // user type ex) free or charge
                    'user_type' : this.loginUser.chargeType,
                    // user company ex) BespinGlobal, SendBird ...
                    'user_company' : this.loginUser.blntCmpnNm + '(' + this.loginUser.blntCmpnId + ')',
                })
            }
        }

    }
</script>

<!--<style src="../../ultiselect/dist/vue-multiselect.min.css"></style>-->
<style lang="scss">
    @import "../static/styles/css/base/index";
    /*@import '../static/styles/idp_front.css';*/
    @import '../node_modules/material-icons/iconfont/material-icons.css';
    @import '../static/styles/governance.ui.css';

    @import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
    @import "../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";

</style>

<style lang="scss">

    @media screen and (min-width: 1920px) {
        .layout-contents-container .layout-contents {
            margin: 0 auto;
            width: 1840px;
        }
    }

    .service-governance {
        .layout-wrap{
            overflow:hidden;
        }
    }

    .layout-contents-container button {
        border-radius: 4px !important;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue